import { useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { Loading } from '../components/Loading';
import ErrorMessageBox from '../components/ErrorMessageBox';
import AuthorMeetingBest from './AuthorMeetingBest';
import { AuthorHeader } from './partials/AuthorHeader';
import { AuthorNav } from './partials/AuthorNav';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { MeetingStage } from './partials/MeetingStage';

export const MEETING_STAGE = {
    READY:0,
    PUZZLE:1,
    COVER:2,
    CARD:3,
    TALK:4,
    END:5,
};

export const AuthorMeeting = ()=>{
    const [stage, setStage] = useState(MEETING_STAGE.READY);
    const id = new URLSearchParams(useLocation().search).get('id');
    
    const {data:meeting, isLoading, isSuccess, isError, error } = useQuery({
        queryKey:['meeting', id],
        queryFn:()=>Api.get(`/api/meeting/${id}`),
        staleTime:1000*60*60
    });
    
    useEffect(() => {
        if(!isSuccess)return setStage(MEETING_STAGE.READY);
        if( meeting?.data?.meetingUser===null){
            // 시작 안했다면
            if( meeting?.data?.meeting===null ){
                setStage(MEETING_STAGE.READY);
            }else if( meeting?.data?.meeting.cover!==null ) {
                setStage(MEETING_STAGE.PUZZLE);    
            }else{
                setStage(MEETING_STAGE.TALK);
            }
            
        }else if( meeting?.data?.meetingUser.state==='start' && meeting?.data?.meeting.cover!=null ){
            setStage(MEETING_STAGE.PUZZLE);
        }else if( meeting?.data?.meeting.bookCard!==null && meeting?.data?.meeting.bookCard.length>0 && meeting?.data?.meetingUser.state==='cover' ){
            setStage(MEETING_STAGE.CARD);
        }else{
            setStage(MEETING_STAGE.TALK);
        }
    }, [isLoading, setStage, meeting, isSuccess]);
    
    if( isLoading ) return <Loading />;
    if( isError ) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
    if( meeting?.data?.meeting.hasBest ) return <AuthorMeetingBest meeting={meeting?.data}  />;

    // 퍼즐
    // 상상
    // 카드보기
    return (
    <div className="subpage">
        <div id="contents" className="meeting_writer">
            <AuthorHeader stage={stage} />
            <AuthorNav stage={stage} meeting={meeting?.data?.meeting} />
            <MeetingStage stage={stage} meeting={meeting?.data} changeStage={setStage}  />
        </div>
    </div>
    ); 
};
